module.exports = __webpack_public_path__ + "static/3-73a4ca030c066f00f11630a6168b450f.jpg";